module.exports = __webpack_public_path__ + "media/failure_long.c27549c9.flac";